import {observable, toJS} from "mobx";
import {appendFieldSpan, formatNullableValue, liberacaoFormatter, montarSelectOption, situacaoFormatter} from '../../../../utils/formatar';
import ImportacaoService from "../../../../services/ImportacaoService";
import {buscaFiltrarVazio, buscaSemResultado} from "../../../../utils/mensagens";
import LoadingImage from "../../../comum/components/LoadingImage";
import React from "react";
import {sortCaret} from "../../../comum/components/Icones";

export default class ImportacaoStore {

    @observable importacoes;
    @observable loading;
    @observable estadoFiltros;

    // Scroll infinito
    @observable lista;
    @observable items;
    toShow;
    turn;
    @observable hasMore;
    @observable noData;
    @observable linhaExpandida;
    @observable tableMessage;

    // Detalhes
    @observable detalhesAtivo;
    @observable linhaDetalhes;
    @observable detalhes;
    @observable carregandoDetalhes;
    @observable tiposDeProcesso;
    @observable tiposDocumento;
    @observable tiposRetiradaCarga;
    @observable tiposNfe;

    @observable listaMensagens;

    // Novo DI
    @observable loadingNovoDi;
    @observable exibirModalNovaDi;
    @observable liberarCriacaoNovaDi;

    constructor() {
        this.importacoes = [];
        this.loading = false;
        this.estadoFiltros = false;

        // Scroll infinito
        this.lista = [];
        this.toShow = 20;
        this.turn = 0;
        this.items = [];
        this.hasMore = false;
        this.noData = <LoadingImage />;
        this.tableMessage = buscaFiltrarVazio;
        this.loading = false;

        this.colunas = this.todasColunas.slice(0);

        this.detalhesAtivo = false;
        this.linhaDetalhes = false;
        this.detalhes = false;
        this.carregandoDetalhes = false;

        this.listaMensagens = false;

        this.loadingNovoDi = false;
        this.exibirModalNovaDi = false;
        this.liberarCriacaoNovaDi =false
        this.dadosParaNovaDi = null;
        this.tituloNovaDi = null;
        this.arquivoParaNovaDi = null;

        this.service = new ImportacaoService();
    }

    // Area lisgatem
    listarImportacoes(filtro) {
        this.estadoFiltros = Object.assign({}, filtro);
        this.fazerListar(filtro);
    };

    reListar = () => {
        this.fazerListar(this.estadoFiltros);
    };

    fazerListar = (filtro) => {
        this.importacoes = [];
        this.lista = [];
        this.items = [];
        this.loading = true;

        this.service.listaProtocolos(filtro.dataInicial, filtro.dataFinal, filtro.bl, filtro.ce, filtro.situacao, filtro.operacao).then(response => {
            this.loading = false;
            if (response.data) {
                this.importacoes = response.data;
            }
            if(this.importacoes.length === 0) {
                this.tableMessage = buscaSemResultado
            } else {
                this.tableMessage = buscaFiltrarVazio
            }
            this.lista = this.importacoes;

            this.noData = this.tableMessage;

            this.loadFirstTurn();
        }).catch(err => {
            console.log(err)
        })
    };

    loadFirstTurn = () => {
        this.items = this.importacoes.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.items.length < this.lista.length;
    };

    loadNextTurn = () => {
        this.items = [];
        this.items = this.lista.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn+1;

        this.hasMore = this.items.length < this.lista.length;
    };
    // Fim Area listagem

    // Area detalhes
    async abrirDetalhes(row, mudaTitulo) {
        this.linhaDetalhes = row;
        //this.listarTiposDocumento();
        this.listarTiposProcesso();
        this.listarTiposRetiradaCarga();
        this.listarTiposNfe();

        this.carregandoDetalhes = true;
        this.detalhes = false;
        const response = await this.service.buscarDetalhes(row.BlId, row.NumeroBl, row.ProtocoloId);
        
        if (response && response.data) {
            response.data.Email = response.data.Email != null?response.data.Email:""
            console.log("emails", response)
            this.carregandoDetalhes = false;
            this.detalhes = {...response.data, BlId: row.BlId, NumeroBl: row.NumeroBl, ProtocoloId: row.ProtocoloId};
            if (this.detalhes.MsgErro && this.detalhes.MsgErro.length > 0) {
                this.listaMensagens = [this.detalhes.MsgErro];
            } else {
                this.detalhesAtivo = true;
                mudaTitulo();
            }
        }
    };

    abrirModalNovaDi = (data, titulo) => {
        this.exibirModalNovaDi = true;
        this.dadosParaNovaDi = data;
        this.tituloNovaDi = titulo;
    }
    
    fecharModalNovaDi = () => {
        this.exibirModalNovaDi = false;
        this.liberarCriacaoNovaDi = false;
        this.arquivoParaNovaDi = null;
        this.dadosParaNovaDi = null;
        this.tituloNovaDi = null;
    }

    adicionarNovoDi = async () => {
    this.loadingNovoDi = true;
    const data = {
        extensao: this.arquivoParaNovaDi.type,
        numDoc: null,
        exigeCPF: false,
        dscArquivo: this.arquivoParaNovaDi.name.replace(/[^a-zA-Z0-9\.]/g, ""),
        blId: this.dadosParaNovaDi.BlId,
        protocoloId: this.dadosParaNovaDi.ProtocoloId,
        tipoDocId: {value: 25} //precisa estar assim devido como foi implementada a chamada de serviço
    };

    let file = new FormData();
    file.append('file', this.arquivoParaNovaDi);

    this.service.salvarDocumento(file, data, "S").then(response => {
        if(response.data && response.data.Sucesso) {
            const novoProtocolo = {...this.dadosParaNovaDi, ProtocoloId: response.data.ProtocoloFilho};
                this.abrirDetalhes(novoProtocolo, this.tituloNovaDi);
            } else {
                this.listaMensagens = ["Não foi possível criar novo DI"];
            }
    }).catch(error => {
        console.error(error);
    }).finally(() => {
        this.loadingNovoDi = false;
        this.liberarCriacaoNovaDi = false;
        this.arquivoParaNovaDi = null;
        this.fecharModalNovaDi();
    });
}

    anexarArquivoNovaDi = async (e) => {
        if(e.target.files.length > 0) {
            this.arquivoParaNovaDi = e.target.files[0]
            this.liberarCriacaoNovaDi = true;
        }
    }

    async atualizaDocumentos(BlId, NumeroBl, ProtocoloId) {
        const response = await this.service.buscarDetalhes(BlId, NumeroBl, ProtocoloId);
        if (response && response.data) {
            this.detalhes.ListaDocumentos = response.data.ListaDocumentos;
        }
    };

    async atualizaNotas(BlId, NumeroBl, ProtocoloId) {
        const response = await this.service.buscarDetalhes(BlId, NumeroBl, ProtocoloId);
        if (response && response.data) {
            this.detalhes.ListaNf = response.data.ListaNf;
        }
    };

    listarTiposDocumento = (BlId, TipoProtocolo) => {
        this.service.listarTiposDocumento(BlId, TipoProtocolo.value).then(response => {
            this.tiposDocumento = montarSelectOption("Id", "Descricao", response.data);
        })
    };

    listarTiposProcesso = () => {
        this.service.listarTipoProcesso(this.linhaDetalhes.BlId).then(response => {
            this.tiposDeProcesso = montarSelectOption("Codigo", "Descr", response.data);
        })
    };

    listarTiposRetiradaCarga = () => {
        this.service.listarTipoRetiradaCarga().then(response => {
            this.tiposRetiradaCarga = montarSelectOption("Codigo", "Descr", response.data);
        })
    };
    listarTiposNfe = () => {
        this.service.listarTipoNfe().then(response => {
            this.tiposNfe = montarSelectOption("Codigo", "Descr", response.data);
        })
    };
    // Fim Area detalhes

    // Exportar
    getLista() {
        return this.importacoes;
    }

    getListaCopia() {
        return toJS(this.importacoes)
    }
    // Fim Exportar

    validaContainerCheio = () => {
        let resultado = true;

        if (this.detalhes.ListaNf && this.detalhes.ListaNf.length > 0)
        {
            let containerCheio = false; 
            this.detalhes.ListaNf.map(nf => 
            {
                if (nf.TipoServico==="CH")
                    containerCheio= true;
            });

            if (containerCheio)
            {
                if (!this.detalhes.ListaBookings || this.detalhes.ListaBookings.length===0)
                    resultado = false;
            }
        }
        
        return resultado        
    }

    todasColunas = [
        {
            dataField:"NumeroBl",
            text:"BL",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField:"NumeroCe",
            text:"CE",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField:"NumeroDi",
            text:"Número DI",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField:"NomeNavio",
            text:"Navio / Viagem",
            sort: true,
            sortCaret: sortCaret,
            formatter: appendFieldSpan,
            formatExtraData: 'CodViagem',
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField:"NomeFantasia",
            text:"Cliente",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField:"ApelidoDespachante",
            text:"Despachante",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField:"Tecon",
            text:"TECON",
            sort: true,
            sortCaret: sortCaret,
            formatter: liberacaoFormatter
        },
        {
            dataField:"Sefaz",
            text:"SEFAZ",
            sort: true,
            sortCaret: sortCaret,
            formatter: liberacaoFormatter
        },
        {
            dataField:"StatusProcesso",
            text:"Situação",
            sort: true,
            sortCaret: sortCaret,
            formatter: situacaoFormatter
        }
    ];
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/stores/ImportacaoStore.js